import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        request_history: {
          header: 'HEADER',
          download_report: 'DOWNLOAD_REPORT',
          aasm_state: {
            approved: 'STATE_APPROVED',
            denied: 'STATE_DENIED',
          },
          change_status_modal: {
            title: 'CHANGE_TITLE',
            question: 'CHANGE_QUESTION',
            answer_yes: 'CHANGE_YES',
            answer_no: 'CHANGE_NO',
          },
          toasts: {
            status_has_been_changed: 'TOAST_STATUS_CHANGED',
          },
        },
      },
    },
  }));
}
